/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/ARMFooterLinks" />
import React = require("react");
import { EndpointsEditorPanelUtils } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { FooterLinks } from "./FooterLinks";


export function ARMFooterLinks(): JSX.Element {
    return (<FooterLinks
        learnMoreLink={EndpointsEditorPanelUtils.AZURE_RM_LEARN_MORE_LINK}
        troubleShootlink={EndpointsEditorPanelUtils.AZURE_RM_TROUBLESHOOT_LINK} />);
}
